import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActiveUsersModel } from './active-users.models';
import { ActiveUsersStore } from './active-users.store';
import { SessionQuery } from '../session/session.query';
import { isOtherUser } from '../../../shared/utils';

@Injectable({ providedIn: 'root' })
export class ActiveUsersQuery extends Query<ActiveUsersModel> {
  protected override store: ActiveUsersStore;
  private readonly _sessionQuery = inject(SessionQuery);

  users$ = this.select((state) => state.users);
  currentCheckpoint$ = this.select((state) => state.currentCheckpoint);
  isFileOutdated$ = this.select((state) => state.isFileOutdated);
  isEnabled$ = this.select((state) => state.isEnabled);
  currentFileDataId$ = this.select((state) => state.currentFileDataId);
  lastModificationEvent$ = this.select((state) => state.lastModificationEvent);

  otherUsers$ = combineLatest([this.users$, this._sessionQuery.select((state) => state.userName)]).pipe(
    map(([users, currentUserName]) => users.filter((u) => isOtherUser(u, currentUserName))),
  );

  hasOtherUsers$ = this.otherUsers$.pipe(map((users) => users.length > 0));

  constructor() {
    const store = inject(ActiveUsersStore);

    super(store);

    this.store = store;
  }

  getUsers() {
    return this.getValue().users;
  }

  getCurrentCheckpoint() {
    return this.getValue().currentCheckpoint;
  }

  isFileOutdated() {
    return this.getValue().isFileOutdated;
  }

  isEnabled() {
    return this.getValue().isEnabled;
  }

  getCurrentFileDataId() {
    return this.getValue().currentFileDataId;
  }

  getLastModificationEvent() {
    return this.getValue().lastModificationEvent;
  }
}
